import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22omnyqra.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./SplineSansMono-Regular.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22./SplineSansMono-Medium.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22preload%22:false,%22variable%22:%22--font-martian-mono%22,%22fallback%22:[%22ui-monospace%22,%22Consolas%22,%22monospace%22]}],%22variableName%22:%22splineSansMono%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'splineSansMono', 'splineSansMono Fallback', ui-monospace, Consolas, monospace",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
